import type {AddBillingAddressPayload} from '@Components/checkout-flow/checkout-flow.types';
import {US_COUNTRY_CODE, US_STATE_UNSELECTED_VALUE} from '@Components/checkout-flow/checkout-flow.types';

export interface BillingAddressFormValues {
  contactName: string;
  streetAddress1: string;
  streetAddress2: string;
  city: string;
  countryCode: string;
  region: string;
  usState: string;
  postalCode: string;
  phone: string;
}

export type BillingAddressFormField = keyof BillingAddressFormValues;

export const BILLING_ADDRESS_FORM_INITIAL_VALUES: BillingAddressFormValues = {
  contactName: '',
  streetAddress1: '',
  streetAddress2: '',
  city: '',
  countryCode: '',
  region: '',
  usState: US_STATE_UNSELECTED_VALUE,
  postalCode: '',
  phone: '',
};

const ADDRESS_LINE_MAX_LENGTH = 200;
const CITY_MAX_LENGTH = 145;
const REGION_MAX_LENGTH = 100;
const POSTAL_CODE_MAX_LENGTH = 20;
const PHONE_MAX_LENGTH = 30;

export const BILLING_ADDRESS_FORM_MAX_LENGTHS: Record<BillingAddressFormField, number> = {
  contactName: ADDRESS_LINE_MAX_LENGTH,
  streetAddress1: ADDRESS_LINE_MAX_LENGTH,
  streetAddress2: ADDRESS_LINE_MAX_LENGTH,
  city: CITY_MAX_LENGTH,
  countryCode: 2,
  region: REGION_MAX_LENGTH,
  usState: 2,
  postalCode: POSTAL_CODE_MAX_LENGTH,
  phone: PHONE_MAX_LENGTH,
};

const ALWAYS_REQUIRED_FIELDS: BillingAddressFormField[] = ['contactName', 'streetAddress1', 'city', 'postalCode', 'countryCode'];

export const getInvalidBillingAddressFields = (values: BillingAddressFormValues): BillingAddressFormField[] => {
  const invalid = ALWAYS_REQUIRED_FIELDS.filter((field) => values[field].trim() === '');
  if (values.countryCode === US_COUNTRY_CODE) {
    if (values.usState === US_STATE_UNSELECTED_VALUE || values.usState === '') {
      invalid.push('usState');
    }
  } else if (values.region.trim() === '') {
    invalid.push('region');
  }
  return invalid;
};

export const toAddBillingAddressPayload = (values: BillingAddressFormValues): AddBillingAddressPayload => {
  return {
    name: values.contactName.trim(),
    address1: values.streetAddress1.trim(),
    address2: values.streetAddress2.trim(),
    city: values.city.trim(),
    region: values.countryCode === US_COUNTRY_CODE ? values.usState : values.region.trim(),
    postalCode: values.postalCode.trim(),
    countryCode: values.countryCode,
    phone: values.phone.trim(),
  };
};
